import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Typography, MenuItem, Select } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Grid
} from '@mui/material';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import axios from 'axios';
import AddDocument from './addFleetDcouments.jsx';
import { useNavigate } from 'react-router-dom';
import TokenError from '../tokenError';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
var constants = require('../../constant');

const FleetDocuments = () => {
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();

    const token = localStorage.getItem('token');
    const ctId = localStorage.getItem('ctId');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [statusFilter, setStatusFilter] = useState('');
    const saveCityIdDriverDoc = localStorage.getItem('saveCityIdDriverDoc');
    // const [cityFilter, setCityFilter] = useState(ctId ? ctId : cities[0].city_id);
    const [cityFilter, setCityFilter] = useState(() => {
        if (!Array.isArray(cities) || cities.length === 0) return null;

        const hasSavedCity = saveCityIdDriverDoc && cities.some((city) => String(city.city_id) === String(saveCityIdDriverDoc));

        if (hasSavedCity) return saveCityIdDriverDoc;
        return cities[0].city_id;
    });
    const [vehicleTypeFilter, setVehicleTypeFilter] = useState('');
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [openAddDocument, setOpenAddDocument] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const loadDocuments = async () => {
            const data = await fetchDocumentsData();
            setRows(data); // Set rows with fetched data
        };
        loadDocuments();
    }, [cityFilter]);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        if (filterType === 'vehicleType') setVehicleTypeFilter(value);
        if (filterType === 'status') setStatusFilter(value);

        setIsFilterApplied(
            Boolean(value) || Boolean(statusFilter) || Boolean(cityFilter) || Boolean(vehicleTypeFilter)
        );
    };

    // const applyOrResetFilter = () => {
    //     if (isFilterApplied) {
    //         setStatusFilter('');
    //         // setCityFilter('');
    //         setVehicleTypeFilter('');
    //         setIsFilterApplied(false);
    //         const resetDocuments = async () => {
    //             const data = await fetchDocumentsData();
    //             setRows(data);
    //         };
    //         resetDocuments();
    //     } else {
    //         const filteredRows = rows.filter((document) =>
    //             (statusFilter ? document.status === statusFilter : true) &&
    //             // (cityFilter ? document.city === cityFilter : true) &&
    //             (vehicleTypeFilter ? document.vehicleType === vehicleTypeFilter : true)
    //         );
    //         setRows(filteredRows);
    //     }
    // };

    const getVehicleType = (type) => {
        return constants.VehicleTypes[type] || "Unknown";
    };

    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1); // Avoid invalid page numbers

    const handleOpenAddDocument = () => {
        setEditMode(false); // Set to "Add" mode
        setSelectedDocument(null); // No pre-filled data
        setOpenAddDocument(true);
    };
    
    const handleCloseAddDocument = () => {
        setOpenAddDocument(false);
    };

    const fetchDocumentsData = async () => {
        try {
            const cityId = cityFilter; // Safely access city_id
            const url = `${serverUrl}/fleet/get_required_documents`;

            const obj={
                token: token, city_id: cityId
            }

            const response =  await makeGetRequestToUrl(url, obj);

            // const response = await axios.get(`https://dev-panel-backend.mobilityinfotech.com/driver/get_required_documents`, {
            //     params: { token, city_id: cityId },
            // });

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }
    
            // Return the data or an empty array if data is missing
            return response.data|| [];
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    // Function for document details
    const handleViewDetails = (row) => {
        setSelectedDocument({
            document_id: row.document_id,
            document_name: row.document_name,
            document_type: row.document_type,
            no_of_images: row.no_of_images,
            is_gallery_restricted: row.is_gallery_restricted,
            is_required : row.is_required,
            is_active: row.is_active,
            is_doc_number_required: row.is_doc_number_required,
            city_name: cities.find(city => city.city_id === row.city_id)?.city_name || '',
            is_doc_expired: row.is_doc_expired,
            expired_action: row.expired_action
        });

        setEditMode(true);

        // Delay setting `openAddDocument` to ensure React processes the previous updates
        setTimeout(() => {
            setOpenAddDocument(true);
        }, 0);
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Fleet Documents
            </Typography>

            <Grid container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '2%' }}>
                {/* Filter controls */}
                <Grid item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item>
                    <Select
                        value={statusFilter}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                </Grid>
                {/* <Grid item style={{ marginLeft: '4%' }}>
                    <Button
                        variant="contained"
                        onClick={applyOrResetFilter}
                        style={{
                            width: '185px',
                            height: '50px',
                            marginRight: '1px',
                            backgroundColor: isFilterApplied ? '#F5BB19' : '#0065FF',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        {isFilterApplied ? 'Reset Filter' : 'Apply Filter'}
                    </Button>
                </Grid> */}
                <Grid item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddDocument}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Document
                    </Button>
                </Grid>
            </Grid>

            {/* Sidebar for AddDocument */}
            <div
                className={`add-driver-document-sidebar ${openAddDocument ? 'open' : ''}`}
                style={{
                    position: 'fixed',
                    top: 65,
                    right: openAddDocument ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <AddDocument
                    onClose={handleCloseAddDocument}
                    editMode={editMode}
                    documentData={selectedDocument || {}}
                />
            </div>

            {/* Documents Table */}
            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                <TableSortLabel
                                    active={orderBy === 'document_id'}
                                    direction={orderBy === 'document_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('document_id')}
                                >
                                    Document ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Document Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Document Category</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Number of Images</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '12.5%' }}>Gallery Restricted</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '12.5%' }}>Document Required</TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '12.5%' }}>Document No. Required</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Document Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .filter((row) => {
                                const isStatusMatch = statusFilter 
                                    ? (statusFilter === 'Active' ? row.is_active === 1 : row.is_active === 0) 
                                    : true;
                                // const isCityMatch = cityFilter ? row.city === cityFilter : true;
                                const isVehicleTypeMatch = vehicleTypeFilter 
                                    ? getVehicleType(row.vehicle_type) === vehicleTypeFilter 
                                    : true;

                                return isStatusMatch && isVehicleTypeMatch;
                            })
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => (
                                <TableRow key={row.document_id}>
                                    <TableCell align="center">{row.document_id}</TableCell>
                                    <TableCell align="center">{row.document_name}</TableCell>
                                    <TableCell align="center">{row.document_type}</TableCell>
                                    <TableCell align="center">{row.no_of_images}</TableCell>
                                    <TableCell align="center">
                                        {row.is_gallery_restricted === 1 ? 'Yes' : 'No'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.is_required === 1 ? 'Yes' : 'No'}
                                    </TableCell>
                                    {/* <TableCell align="center">
                                        {row.is_doc_number_required === 1 ? 'Yes' : 'No'}
                                    </TableCell> */}
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            style={{
                                                backgroundColor: row.is_active === 1 ? '#0DBA78' : '#D14545',
                                                color: 'white',
                                                textTransform: 'none',
                                                pointerEvents: 'none',
                                                borderRadius: '8px',
                                                minWidth: '120px',
                                            }}
                                        >
                                            {row.is_active === 1 ? 'Active' : 'Inactive'}
                                        </Button>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleViewDetails(row)}
                                            sx={{
                                                backgroundColor: 'white',
                                                color: 'black',
                                                border: '1px solid black',
                                                textTransform: 'none',
                                                borderRadius: '8px',
                                                width: 'auto', // Or set a specific width
                                                minWidth: '120px', 
                                                '&:hover': {
                                                    backgroundColor: 'black',
                                                    color: 'white',
                                                },
                                                '&:active': {
                                                    backgroundColor: 'black',
                                                    color: 'white',
                                                },
                                            }}
                                        >
                                            View Details
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                
                {/* Pagination */}
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${
                                        page === index ? 'active' : ''
                                    }`}
                                >
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>
                
        </div>
    );
};

export default FleetDocuments;